var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{class:{
    [_vm.$style.grayContainer]: _vm.isExpiringLater || _vm.noBackground,
    [_vm.$style.redContainer]: _vm.isExpired && !_vm.noBackground,
    [_vm.$style.yellowContainer]: _vm.isExpiringSoon && !_vm.noBackground,
  }},[_vm._v(" "+_vm._s(_vm.expiryDateDisplay)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }